import { RefObject, createContext, useContext } from 'react';

export const FormScrollContext = createContext<RefObject<HTMLDivElement> | null>(null);

export function useFormScrollContext() {
  return useContext(FormScrollContext);
}
